module.exports = __webpack_public_path__ + "static/img/wsbxright.cd993ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wsbxright.png
// module id = 3lzu
// module chunks = 1